import { SONHTMLContent } from '../Wysiwyg';
import { UserProfile } from '../../../types/api/UserProfile';
import IForm from '../../../types/IForm';
import { IFileItem } from '../../../types/api/FileItem';

export type PostFirstTypes = 'comment' | 'thread';
export type PostTypes = PostFirstTypes | 'reply';

// a PostReply is the same as a Post, but it cant have attachments and replies
// export type PostReply = Omit<PostFirst, 'replies' | 'attachments' | 'attachedFileUpdateOrder' | 'replyForm'>;
export type PostReply = SONHTMLContent & {
  id: string;
  createDate: string;
  author: UserProfile;
  updateForm?: IForm;
  deleteForm?: IForm;
  editDate?: string;
};
export type PostFirst = PostReply & {
  replyForm: IForm;
  replies?: PostReply[];
  attachments?: IFileItem[];
  attachedFileUpdateOrder?: IForm;
};

export function isPostFirst(post: PostFirst | PostReply): post is PostFirst {
  const postFirst = post as PostFirst;
  return !!postFirst.replyForm;
}
